import { useState, useEffect } from 'react';
import { Course } from '../types';
import { getCourse } from '../config/courses';

interface CourseState {
  course: Course | null;
  isLoading: boolean;
  error: string | null;
}

export function useCourse(courseId: string): CourseState {
  const [state, setState] = useState<CourseState>({
    course: null,
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    let mounted = true;

    async function loadCourse() {
      try {
        setState(prev => ({ ...prev, isLoading: true, error: null }));
        const course = await getCourse(courseId);

        if (!mounted) return;

        if (course) {
          setState({ course, isLoading: false, error: null });
        } else {
          setState({ course: null, isLoading: false, error: 'Kurs nicht gefunden' });
        }
      } catch (error) {
        if (!mounted) return;
        setState({ course: null, isLoading: false, error: 'Fehler beim Laden' });
      }
    }

    loadCourse();

    return () => {
      mounted = false;
    };
  }, [courseId]);

  return state;
}
